import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  useMediaQuery,
} from "@mui/material";
import SnackBar from "./SnackBar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { add_template } from "../Api service/APIvariables";
import { height } from "@mui/system";

const Template = () => {
  const [template_name, setTemplateName] = useState("");
  const [subject, setSubject] = useState("");
  // const [message, setMessage] = useState(""); // Plain text message
  const [richContent, setRichContent] = useState(""); // Quill rich text
  const isMobile = useMediaQuery("(max-width: 768px)"); // Detect mobile screens

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false);
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!template_name || !subject || !richContent) {
      setMessage("All fields are required!");
      setOpen(true);
      setColor(false);
      setStatus(false);
      return;
    }

    setLoading(true);

    // Prepare form data with FormData and append necessary fields
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("user_id"));
    formData.append("template_name", template_name);
    formData.append("subject", subject);
    formData.append("message", richContent); // Use richContent for the "message" field

    const token = localStorage.getItem("auth_token");

    if (!token) {
      setMessage("Token is missing or invalid!");
      setOpen(true);
      setColor(false);
      setStatus(false);
      setLoading(false);
      return;
    }

    try {
      // API call using fetch with FormData and Authorization header
      const response = await fetch(add_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // Pass token in the header
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Template created successfully!");
        setOpen(true);
        setStatus(true);
        setColor(true);
        setTemplateName("");
        setSubject("");
        // setMessage(""); // Clear message
        setRichContent(""); // Clear rich content
      } else {
        setMessage(`Error: ${data?.message || "Unknown error"}`);
      }
    } catch (error) {
      setMessage(`Error during submission: ${error.message}`);
      setColor(false);
      setOpen(true);
      setStatus(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="template"
      style={{
        display: "block",
        // backgroundColor: "#eceff1",
        minHeight: "100vh",
        // padding: "20px",
        position: "relative",
        width: "100%",
        // maxWidth: "98%",
        margin: "0 auto",
        // borderRadius: "30px",
        // paddingRight: "20px",
        paddingLeft: "20px",
        paddingRight: isMobile ? "15px" : "0px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SnackBar
        open={open}
        message={message}
        setOpen={setOpen}
        status={status}
        color={color}
      />
      <Container
        maxWidth="800px"
        sx={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          border: "1px solid #CFD8DC",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Box mb={2}>
            <label style={{ marginBottom: 3, fontWeight: 600 }}>
              Template Name
            </label>
            {/* <TextField
              fullWidth
              value={template_name}
              onChange={(e) => setTemplateName(e.target.value)}
              sx={{ marginBottom: 1, height: { xs: 30, sm: 38, md: 45 } }}
            /> */}

            <input
              type="text"
              value={template_name}
              onChange={(e) => setTemplateName(e.target.value)}
              style={{
                display: "block",
                width: "100%",
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #e0e0e0",
              }}
            />
          </Box>

          <Box mb={2}>
            <label style={{ marginBottom: 3, fontWeight: 600 }}>Subject</label>
            {/* <TextField
              fullWidth
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              style={{ marginBottom: 1, height: { xs: 30, sm: 38, md: 45 } }}
            /> */}
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              style={{
                display: "block",
                width: "100%",
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #e0e0e0",
              }}
            />
          </Box>

          <Box mb={2}>
            <label style={{ marginBottom: 3, fontWeight: 600 }}>Message</label>
            <ReactQuill
              value={richContent}
              onChange={setRichContent} // Update richContent with ReactQuill
              style={{
                height: "200px",
                marginBottom: "20px",
                fontSize: { xs: "8px", sm: "12px" },
                borderRadius: "8px",
                // border: "1px solid #e0e0e0",
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: { xs: "100px", sm: "60px" },
            }}
          >
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                backgroundColor: "#453c72",
                fontSize: { xs: "14px", sm: "12px" },
              }}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Box>

          {/* {statusMessage && <p>{statusMessage}</p>} */}
        </form>
      </Container>
    </div>
  );
};

export default Template;
